import React from 'react'

export default function Error() {
  return (
    <main className='err-page'>
      <div className="err-title-container">
      <h1 className="err-code">404</h1>
      <h4 className="err-title">Page is Not Found</h4>
        </div>
    </main>
  )
}
